var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12 box-release"},[_c('HeatMap')],1),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-6 box-release"},[_c('HeatMapSensor')],1),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-6 box-release"},[_c('HeatMapSensorAppointments')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-140aeae3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Pages/Online2.vue
// module id = /wqj
// module chunks = 6